import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from '../../../util/toast';

import { useCreatePaylinkCustomerMutation, mmsApi } from '../../../store/modules/merchant/api';
import { isServerError } from '../../../util/helpers';
import { CreatePaylinkCustomerBody } from '../../../store/modules/merchant/types';

type UseCustomerSubmitProps = {
  merchantId: string;
};

export const useCustomerSubmit = ({ merchantId }: UseCustomerSubmitProps) => {
  const [createPaylinkCustomer, { isLoading: isLoadingCreateCustomer }] =
    useCreatePaylinkCustomerMutation();
  const [serverValidationError, setServerValidationError] = useState<string | undefined>(undefined);

  const dispatch = useDispatch();

  const onCustomerSubmit = async (addCustomerBody: Partial<CreatePaylinkCustomerBody>) => {
    setServerValidationError(undefined);

    try {
      await createPaylinkCustomer({
        ...addCustomerBody,
        merchantId,
      }).unwrap();

      // let create go through before refetching
      setTimeout(() => {
        dispatch(mmsApi.util.invalidateTags([{ type: 'Customer', id: 'ALL' }]));
      }, 100);
    } catch (err) {
      if (isServerError(err) && err.data.statusCode === 400) {
        setServerValidationError(err.data.message);
        throw new Error(err.data.message);
      }
      if (isServerError(err) && err.data.statusCode === 409) {
        setServerValidationError(
          'Customer already exists. Please try again using different customer information.',
        );
        throw new Error(err.data.message);
      }
      const errorMessage = 'Something went wrong while adding the customer, please try again later';
      toast.error(errorMessage);
      throw err;
    }

    toast.success('Customer successfully added.');
  };

  return {
    onCustomerSubmit,
    isLoading: isLoadingCreateCustomer,
    serverValidationError,
  };
};
